import actions from './actions';

const initialState = {
    currentUser: null,
    loadingUser: false
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_USER_SIIGO_REQUEST:
            return {
                ...state,
                loadingUser: true,
            }
        case actions.SET_CURRENT_USER_SIIGO:
            return {
                ...state,
                currentUser: action.currentUser,
                loadingUser: false,
            }
        case actions.CLEAR_CURRENT_USER_SIIGO:
            return {
                ...state,
                currentUser: null,
                loadingUser: false
            }
        default:
            return state;
    }

}
